import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getUserGeoData } from "./services/geoService";
import { trackVisit } from "./services/newsletterService";
// import Footer from "./Components/Footer";
import FloatingNav from "./Components/FloatingNav";
import Home from "./Components/Home";
import Gispert1 from "./Components/Gispert1";
import Gispert2 from "./Components/Gispert2";
import Gispert3 from "./Components/Gispert3";
import Gispert4 from "./Components/Gispert4";
import Gispert5 from "./Components/Gispert5";
import Gispert6 from "./Components/Gispert6";
import Instructivo from "./Components/Instructivo";
import Introduccion from "./Components/Introduccion";
import Museo1 from "./Components/Museo1";
import Museo2 from "./Components/Museo2";
import Newsletter from "./Components/Newsletter";
import MoveToTop from "./Components/MoveToTop";

import SpiralsBg from "./Components/SpiralsBg";
import { GiCrossedChains } from "react-icons/gi";


function App() {
  const [Loading, SetLoading] = useState(true);
  const location = useLocation();
  const isHome = location.pathname === '/';
  // Only Gispert sections are light-themed
  const isLightRoute = /^\/Gispert[1-6]$/.test(location.pathname);

  // Prevent elastic overscroll from revealing blue background on white pages
  useEffect(() => {
    if (isLightRoute) {
      document.body.style.backgroundColor = '#ffffff';
      document.documentElement.style.backgroundColor = '#ffffff';
    } else {
      document.body.style.backgroundColor = 'var(--color-bg-primary)';
      document.documentElement.style.backgroundColor = 'var(--color-bg-primary)';
    }

    // Cleanup on unmount (though this app doesn't strictly unmount App)
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, [isLightRoute]);

  useEffect(() => {
    SetLoading(true)

    setTimeout(() => {
      SetLoading(false)
    }
      , 1900)
  }, [])

  // Registrar visita del usuario al cargar la página
  useEffect(() => {
    getUserGeoData()
      .then((geoData) => {
        trackVisit(geoData).catch((err) =>
          console.error("Error tracking visit:", err)
        );
      })
      .catch(() => {
        trackVisit({}).catch((err) =>
          console.error("Error tracking visit:", err)
        );
      });
  }, []);

  return (
    <>
      {Loading ? (
        <div className="loader" aria-label="Cargando">
          <span className="loader-chains">
            <GiCrossedChains size={80} />
          </span>
        </div>
      ) : (
        <div className={`App-wrap${isLightRoute ? ' App-wrap--gispert' : ''}`}>
          <SpiralsBg />
          {!isHome && <FloatingNav />}
          <MoveToTop />

          <div className="App-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Creditos" element={<Navigate to="/" replace />} />
              {/* <Route path="/Project" element={<Project />} /> */}
              <Route path="/Gispert1" element={<Gispert1 />} />
              <Route path="/Gispert2" element={<Gispert2 />} />
              <Route path="/Gispert3" element={<Gispert3 />} />
              <Route path="/Gispert4" element={<Gispert4 />} />
              <Route path="/Gispert5" element={<Gispert5 />} />
              <Route path="/Gispert6" element={<Gispert6 />} />
              <Route path="/Instructivo" element={<Instructivo />} />
              <Route path="/Introduccion" element={<Introduccion />} />
              <Route path="/Museo1" element={<Museo1 />} />
              <Route path="/Museo2" element={<Museo2 />} />
              <Route path="/VisitorRegistration" element={<Newsletter />} />
            </Routes>

            {/* {!isHome && <Footer />} */}
          </div>
        </div>
      )}
    </>
  );
}

export default App;
